export const ADD_ITEM = 'ADD_ITEM';
export const ADD_PATH = 'ADD_PATH';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_LENGTH = 'SET_LENGTH';
export const GO_BACK = 'GO_BACK';
